import type { GetCustomAttributeSchemaAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetCustomAttributeSchemaAuditByIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetCustomAttributeSchemaAuditByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetCustomAttributeSchemaAuditByIdArgs = { id: string };

export const useGetCustomAttributeSchemaAuditById = createQueryHook<
  UseGetCustomAttributeSchemaAuditByIdArgs,
  GetCustomAttributeSchemaAuditByIdResponseRow[],
  GetCustomAttributeSchemaAuditByIdQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getCustomAttributeSchemaAuditById.queryOptions({
      id,
    }),
  mapTrpcDataToGraphQL: (data) => ({
    custom_attribute_schema_audit: data || [],
  }),
  graphqlDocument: GetCustomAttributeSchemaAuditByIdDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
